import { useState, useEffect, useContext } from 'react';
import { IUserDetailsInfo } from 'teko-oauth2';
import userHelpers from 'helpers/user';
import { userServices } from 'services';
import { IBaseRoute } from 'data';
import { StoreContext } from 'contexts';

const useUserInfo = () => {
  const [currentUser, setCurrentUser] = useState<IUserDetailsInfo>();

  const getFullUserInfo = async () => {
    const fullUserInfo = await userServices.getFullUserInfo();
    if (fullUserInfo) {
      setCurrentUser(fullUserInfo);
    }
  };

  useEffect(() => {
    getFullUserInfo();
  }, []);

  return { currentUser };
};

const useAuthorizationData = (items: IBaseRoute[]) => {
  const { currentUser } = useContext(StoreContext);

  // Get navigation which match permissions to build menu
  const filteredNavigation = userHelpers.filterHasPermissions(
    items,
    currentUser.permissions
  );

  // Only get routes which is link to a component
  const filteredRoutes = getAllFilteredRoutes(filteredNavigation);

  return {
    filteredNavigation,
    filteredRoutes,
  };
};

function getAllFilteredRoutes(routes: IBaseRoute[]): IBaseRoute[] {
  let filteredRoutes: IBaseRoute[] = [];

  routes.forEach((item) => {
    if (!item.subMenu && item.component) {
      filteredRoutes.push(item);
    } else if (item.subMenu) {
      filteredRoutes = filteredRoutes.concat(
        getAllFilteredRoutes(item.subMenu)
      );
    }
  });

  return filteredRoutes;
}

export default {
  useUserInfo,
  useAuthorizationData,
};
